var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import { useTabContext } from "./Tab.context.js";
import styles from "@bookingcom/bui-core/css/Tab.module.css";
var TabPanel = function (props) {
    var id = props.id, children = props.children, keepMounted = props.keepMounted, mixin = props.mixin, attributes = props.attributes;
    var activeTabId = useTabContext().activeTabId;
    var isActive = id === activeTabId;
    var rootClassName = classNames(styles["item-panel"], isActive && styles["item-panel--active"], mixinClassNames(mixin));
    if (!isActive && !keepMounted)
        return null;
    return (React.createElement("div", __assign({}, attributes, { role: "tabpanel", id: id, className: rootClassName, style: mixinStyles(mixin) }), children));
};
export default TabPanel;
